/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SliceName } from '../constants';

export const policySlice = createSlice({
  name: SliceName.Policy,
  initialState: {
    email: '',
    orderNumber: '',
    firstName: '',
    policyList: [],
    reasonList: [],
    paymentMethod: {},
    behaviorData: {},
  },
  reducers: {
    setPolicyInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      const { email, orderNumber } = payload;
      state.email = email;
      state.orderNumber = orderNumber;
    },
    setCustomerInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      const {
        firstName, policyList, applicantEmail, adminDomain,
      } = payload;
      state.firstName = firstName;
      state.adminDomain = adminDomain;
      state.policyList = policyList;
      if (applicantEmail) {
        state.email = applicantEmail;
      }
    },
    setRAReasonList(state, { payload }) {
      if (!payload) {
        return;
      }
      state.reasonList = payload;
    },
    // 用于记录理赔埋点信息
    setBehaviorData(state, { payload }) {
      if (!payload) {
        return;
      }
      state.behaviorData = { ...payload };
    },

  },
});

export const {
  setPolicyInfo, setCustomerInfo, setRAReasonList, setBehaviorData,
} = policySlice.actions;

export default policySlice.reducer;
